import { createAsyncThunk } from '@reduxjs/toolkit'
import RestClient from '../../../services/client/RestClient'
import Configuration from '../../../services/api/Configuration'
import { addToArrIfNotExistOrRemove } from '../../../utils/helpers'

const { Users_Batch_Actions_Status_Endpoints } = Configuration

export const usersBatchActionsStatusResetAlertHandler = createAsyncThunk(
  'usersBatchActionsStatus/usersBatchActionsStatusResetAlertHandler',
  async () => ({}),
)

export const getUsersBatchActionsStatusList = createAsyncThunk(
  'usersBatchActionsStatus/getUsersBatchActionsStatusList',
  async (_, { rejectWithValue }) => {
    const api = Users_Batch_Actions_Status_Endpoints()

    const response = await RestClient.getRequest(api.list)

    if (response.status >= 300) {
      return rejectWithValue(response)
    }

    return response.data
  },
)
export const changeStatusProcessActionsStatusList = createAsyncThunk(
  'usersBatchActionsStatus/changeStatusProcessActionsStatusList',
  async ({ queries }, { rejectWithValue, getState }) => {
    const api = Users_Batch_Actions_Status_Endpoints(queries)
    const { language } = getState()

    const response = await RestClient.putRequest(`${api.ChangeStatusProcess}`, {})

    if (response.status >= 300) {
      return rejectWithValue(response)
    }

    return {
      status: 201,
      severity: 'success',
      message: language?.translations?.['Status has been changed successfully'],
    }
  },
)

export const getUsersBatchActionsStatusListRefreshBtn = createAsyncThunk(
  'usersBatchActionsStatus/getUsersBatchActionsStatusListRefreshBtn',
  async (_, { rejectWithValue, getState }) => {
    const { usersBatchActionsStatus } = getState()
    const api = Users_Batch_Actions_Status_Endpoints()

    const filters = createReqHelper(usersBatchActionsStatus, {})

    const response = await RestClient.getRequest(`${api.list}?${filters}`)

    if (response.status >= 300) {
      return rejectWithValue(response)
    }

    return response.data
  },
)

export const getFilterUsersBatchActionsStatusList = createAsyncThunk(
  'usersBatchActionsStatus/getFilterUsersBatchActionsStatusList',
  async ({ queries }, { rejectWithValue, getState }) => {
    const { usersBatchActionsStatus } = getState()
    const api = Users_Batch_Actions_Status_Endpoints()

    let newFilterArr
    const filterIds = []

    if (queries === 'clear') {
      newFilterArr = []
    } else if (Array.isArray(queries)) {
      newFilterArr = queries
    } else {
      newFilterArr = addToArrIfNotExistOrRemove(usersBatchActionsStatus.activeFilters, 'id', queries)
    }

    newFilterArr.forEach((singleFilter) => {
      filterIds.push(singleFilter.id)
    })

    const filters = createReqHelper(usersBatchActionsStatus, { key: 'activeFilters', value: newFilterArr })

    const response = await RestClient.getRequest(`${api.list}?${filters}`)

    if (response.status >= 300) {
      return rejectWithValue(response)
    }

    return {
      response: response.data,
      filters: newFilterArr,
    }
  },
)

export const getSortUsersBatchActionsStatusList = createAsyncThunk(
  'usersBatchActionsStatus/getSortUsersBatchActionsStatusList',
  async ({ queries }, { rejectWithValue, getState }) => {
    const { usersBatchActionsStatus } = getState()
    const api = Users_Batch_Actions_Status_Endpoints()

    const filters = createReqHelper(usersBatchActionsStatus, { key: 'activeSort', value: queries })

    const response = await RestClient.getRequest(`${api.list}?${filters}`)

    if (response.status >= 300) {
      return rejectWithValue(response)
    }

    return {
      response: response.data,
      sort: queries,
    }
  },
)

export const statusEmployeesListPagination = createAsyncThunk(
  'usersBatchActionsStatus/statusEmployeesListPagination',
  async ({ queries }, { getState, rejectWithValue }) => {
    const { usersBatchActionsStatus } = getState()
    const api = Users_Batch_Actions_Status_Endpoints()
    const filters = createReqHelper(usersBatchActionsStatus, { key: 'pageNumber', value: queries })
    const response = await RestClient.getRequest(`${api.list}?${filters}`)

    if (response.status >= 300) {
      return rejectWithValue(response)
    }

    return {
      response: response.data,
      pageNumber: queries,
    }
  },
)

function createReqHelper(store, { key, value }) {
  const copyStore = { ...store }
  if (key) {
    copyStore[key] = value
  }
  const getFilterIds = (filters) => (filters || []).map((filter) => filter.id)
  const filterStatusIds = getFilterIds(copyStore?.activeFilters)?.join('&status_ids=')

  const {
    pageSize,
    activeSort,
    pageNumber,
  } = copyStore

  const response = [
    `page_number=${pageNumber || 0}`,
    `page_size=${pageSize}`,
    `sort_by=${activeSort?.key || ''}`,
    `status_ids=${filterStatusIds}`,
  ].join('&')
  return response
}
